// Compatibility page for links in historical emails.
//
// The legacy self-hosted unsubscribe handler (handle-email-unsubscribe) and its
// token/suppression tables were retired when email delivery moved to the
// managed provider. Unsubscribe is now handled by the managed footer link in
// each email. Old messages may still link here, so this route stays mounted and
// returns a graceful, informational state instead of an error.
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const CONTACT_EMAIL = "silversagehomeschoolhubs@gmail.com";

const Unsubscribe = () => {
  return (
    <div className="public-site min-h-screen bg-background flex items-center justify-center p-4 pt-20">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Email preferences</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p>
            Email preferences are now managed directly from the unsubscribe link at
            the bottom of any recent Silver Sage email.
          </p>
          <p>
            If you would like to stop receiving messages and cannot find that link,
            email us at{" "}
            <a className="text-primary underline" href={`mailto:${CONTACT_EMAIL}`}>
              {CONTACT_EMAIL}
            </a>{" "}
            and we will take care of it for you.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Unsubscribe;
